import { combineReducers } from 'redux';
import admin from './admin';

export default combineReducers({
  admin,
});
